import * as React from "react";
import { reducer, initState } from "../../../../reducers/report/key-mearurements";
import { Loading } from "../../../../../../react-components/lu-component/src/index";
import { ConfirmBox } from "../../../../components/parts/confirm-box";
import { get, makeError } from "../../../../lib/request";
import { v3ApiEndpoint } from "../../../../../../server/router/endpoint";
import { useParams } from "react-router-dom";
import { GetKeyMeasurementsResponse } from "../../../../../../server/types/request/report/key-mesurements";
import { KeyMeasurementsReportPage } from "../../../../components/pages/report/key-measurements";
import { RetestMenu } from "../../../../components/pages/report/common";

export const KeyMeasurementsReportContainer = () => {
	const [state, dispatch] = React.useReducer(reducer, initState);
	const { loading, info, ...keyMeasurementsProps } = state;
	const { jobId, activityId } = useParams<{
		jobId: string;
		activityId: string;
	}>();
	React.useEffect(() => {
		get<GetKeyMeasurementsResponse>(`${v3ApiEndpoint.keyMeasurementsReport}/${jobId}`)
			.then((response) => {
				dispatch({ type: "loadData", payload: response.data });
			})
			.catch((error) => {
				dispatch({ type: "changeMessageInfo", payload: makeError(error) });
			});
	}, [jobId]);
	return (
		<>
			<Loading loading={loading} />
			{keyMeasurementsProps.job && keyMeasurementsProps.job.retestJobId && (
				<RetestMenu
					activityId={activityId}
					jobId={keyMeasurementsProps.job.retestJobId.toString()}
					page={"key-mesurements"}
					latest
				/>
			)}
			<ConfirmBox info={info} />
			{<KeyMeasurementsReportPage {...keyMeasurementsProps} />}
		</>
	);
};
